import React from 'react';
import './Badge.css';

function Badge({ type }) {
  const label = type === 'CHANNEL' ? 'Channel' : type === 'GROUP' ? 'Group' : 'DM';
  return <span className={`badge badge-${type?.toLowerCase() || 'dm'}`}>{label}</span>;
}

export default Badge;
